import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
// import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class ListUsersService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    // private common: DatabaseCacheService
  ) { }

  // listUsers() {
  //   let sectionId = this.common.getSelectedSection().sectionId;

  //   // this.storeAuth.getSection().subscribe((v) => {
  //   //   if (!v) {
  //   //     this.sectionId = localStorage.getItem('gokuri.sectionId');
  //   //   } else {
  //   //     this.sectionId = v;
  //   //   }
  //   // });

  //   let user = this.msalService.instance.getActiveAccount();
  //   let loginUserId = JSON.stringify(user.idTokenClaims['sub']);


  //   let headers = new HttpHeaders({
  //     'Content-Type': 'application/json'
  //   });

  //   headers = headers.set('LoginUserId', loginUserId)
  //     .set('Access-Control-Allow-Origin', '*');


  //   return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/users`, { headers: headers });
  // }

  listUserWithUserData(sectionId : string, getContributors : boolean = false, getUserdata : boolean = true, activeUsersOnly : boolean) {
    // 指定された section のユーザ一覧を取得する
    // getContributors=true が指定されていると、各ユーザに割り当てられている Contributor のリストも合わせて返す
    // getUserdata = true が指定されていると、各ユーザの UserData の最新２件も合わせて返す
    // activeUsersOnly = true が指定されていると、ContractStatus が OPEN のものだけを返す

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    headers = headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    let params = new HttpParams();

    if (getContributors){
      params = params.set('getContributors', 'true');
    }

    if (getUserdata){
      params = params.set('getUserdata', 'true');
    }

    if (activeUsersOnly){
      params = params.set("activeUsersOnly", "true");
    }
    else{
      params = params.set("activeUsersOnly", "false");
    }

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/userlist/userdata`, { headers: headers, params : params });
  }
}
